import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Win = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!location.state || location.state.hops == null || !location.state.path || !location.state.startActor) {
    navigate('/', { replace: true });
    return null;
  }

  const { hops, path, startActor, endActor } = location.state;

  return (
    <div className="min-h-screen bg-[#fdf6ec] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-sm">

        <div className="text-center mb-6">
          <div className="text-5xl mb-3">🎬</div>
          <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
            FILMQUEST
          </span>
          <h1 className="text-3xl font-black text-[#1a1a1a] mt-3 mb-1">You did it!</h1>
          <p className="text-sm text-[#888]">{startActor.name} → {endActor.name}</p>
        </div>

        <div className="bg-white border-[3px] border-[#1a1a1a] rounded-xl p-5 shadow-[5px_5px_0_#1a1a1a] text-center mb-4">
          <p className="text-xs font-black text-[#888] uppercase tracking-widest mb-1">Connected in</p>
          <div className="text-6xl font-black text-[#ff6b35] leading-none">{hops}</div>
          <p className="text-sm font-bold text-[#1a1a1a] mt-1">{hops === 1 ? 'hop' : 'hops'}</p>
        </div>

        <div className="bg-white border-2 border-[#ddd] rounded-xl p-4 mb-6">
          <p className="text-xs font-black text-[#888] uppercase tracking-widest mb-3">Your path</p>
          <div className="flex flex-col gap-2">
            {path.map((entry, i) => (
              <React.Fragment key={i}>
                <div className="flex items-center gap-2">
                  <span className={`text-white text-[9px] font-black px-2 py-0.5 rounded flex-shrink-0 ${i === 0 ? 'bg-[#ff6b35]' : 'bg-[#1a1a1a]'}`}>
                    {i === 0 ? 'START' : `HOP ${i}`}
                  </span>
                  <span className="text-sm font-bold text-[#1a1a1a]">{entry.actor.name}</span>
                </div>
                <div className="flex items-center gap-2 pl-4 text-xs text-[#888]">
                  <span className="text-[#ccc]">↓</span>
                  <span>{entry.movie.title ?? entry.movie.name}</span>
                </div>
              </React.Fragment>
            ))}
            <div className="flex items-center gap-2">
              <span className="bg-[#ff6b35] text-white text-[9px] font-black px-2 py-0.5 rounded flex-shrink-0">
                GOAL
              </span>
              <span className="text-sm font-bold text-[#ff6b35]">{endActor.name}</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate('/')}
            className="bg-[#ff6b35] text-white font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
          >
            🎲 Play Again
          </button>
          <button
            onClick={() => navigate('/credits')}
            className="bg-white text-[#1a1a1a] font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
          >
            🏠 Credits
          </button>
        </div>

      </div>
    </div>
  );
};

export default Win;
